import { render } from "./ChartBar.vue?vue&type=template&id=5348ef3e&scoped=true"
import script from "./ChartBar.vue?vue&type=script&lang=js"
export * from "./ChartBar.vue?vue&type=script&lang=js"

import "./ChartBar.vue?vue&type=style&index=0&id=5348ef3e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5348ef3e"]])

export default __exports__